import { useCallback, useMemo } from 'react';
import {
  getWorkspaceId,
  useAppSelector,
  useTemplateListMutation,
  EachWabaTemplatesRes,
} from '@zonofi/zono-money-store';
import { useDebounceSearch, usePaginatedList } from '../../hooks';

export const useGetTemplateList = () => {
  const sellerWorkspaceId = useAppSelector(getWorkspaceId);
  const [templateListApi, templateListApiResponse] = useTemplateListMutation();
  const { debouncedSearchValue } = useDebounceSearch();

  const fetchtemplateListApi = useCallback(
    (params: { pageNo: number; pageSize: number }) => {
      templateListApi({
        sellerWorkSpaceId: sellerWorkspaceId,
        platformFlag: false,
        filters: {
          MetaTag: 'CollectDigitalOrders',
        },
        ...params,
        ...(debouncedSearchValue ? { searchKey: debouncedSearchValue } : {}),
      });
    },
    [debouncedSearchValue]
  );

  const memoizedTemplateData = useMemo(() => {
    return templateListApiResponse.data?.wabaTemplates ?? [];
  }, [templateListApiResponse.data]);

  const {
    data: templateListData,
    pageNo,
    lastItemRef,
    onScroll,
    isEndOfList,
    refresh,
  } = usePaginatedList<EachWabaTemplatesRes>({
    fetchDataApiCall: fetchtemplateListApi,
    apiResponseData: memoizedTemplateData,
    isLoading: templateListApiResponse.isLoading,
    uniqueKey: 'id',
    dependencies: [debouncedSearchValue],
    isError: templateListApiResponse.isError,
    paginationMeta: {
      startRecord: templateListApiResponse.data?.pagination?.startRecord ?? 0,
      endRecord: templateListApiResponse.data?.pagination?.endRecord ?? 0,
      totalCount: templateListApiResponse.data?.pagination?.total ?? 0,
    },
  });

  return {
    templateListData,
    pageNo,
    lastItemRef,
    onScroll,
    isEndOfList,
    isLoading: templateListApiResponse?.isLoading,
    refresh,
  };
};
